import { render, staticRenderFns } from "./UeberMich.vue?vue&type=template&id=45870518&scoped=true&"
import script from "./UeberMich.vue?vue&type=script&lang=js&"
export * from "./UeberMich.vue?vue&type=script&lang=js&"
import style0 from "./UeberMich.vue?vue&type=style&index=0&id=45870518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45870518",
  null
  
)

export default component.exports